module.exports = __webpack_public_path__ + "img/page_cam_slider_03.43cf5c49.png";